import React, { Component } from "react";
import "./BykKompletni.css";
import { findClass } from "../../../shared/utility";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";
import { relative } from "path";
import Scroll from "react-scroll";

class BykKompletni extends Component {
  componentDidMount() {
    if (window.innerHeight < 800) {
      Scroll.animateScroll.scrollTo(176); //39 u sebe
    }
  }
  state = {
    parts: [
      {
        id: "Licka",
        class: "unselected",
      },
      {
        id: "Jazyk",
        class: "unselected",
      },
      {
        id: "Krk",
        class: "unselected",
      },
      {
        id: "Hrudi",
        class: "unselected",
      },
      {
        id: "Podpleci",
        class: "unselected",
      },
      {
        id: "VRostenec",
        class: "unselected",
      },
      {
        id: "KPlec",
        class: "unselected",
      },
      {
        id: "LPlec",
        class: "unselected",
      },
      {
        id: "VPlec",
        class: "unselected",
      },
      {
        id: "Husicka",
        class: "unselected",
      },
      {
        id: "KPredni",
        class: "unselected",
      },
      {
        id: "VZebro",
        class: "unselected",
      },
      {
        id: "ZHole",
        class: "unselected",
      },
      {
        id: "Oponka",
        class: "unselected",
      },
      {
        id: "Veverka",
        class: "unselected",
      },
      {
        id: "NRostenec",
        class: "unselected",
      },
      {
        id: "Svickova",
        class: "unselected",
      },
      {
        id: "ZNizke",
        class: "unselected",
      },
      {
        id: "PupekFlank",
        class: "unselected",
      },
      {
        id: "PupekFlap",
        class: "unselected",
      },
      {
        id: "Holubicka",
        class: "unselected",
      },
      {
        id: "Orech",
        class: "unselected",
      },
      {
        id: "KvetovaSpicka",
        class: "unselected",
      },
      {
        id: "TabulovaSpicka",
        class: "unselected",
      },
      {
        id: "VrchniSal",
        class: "unselected",
      },
      {
        id: "SpodniSal",
        class: "unselected",
      },
      {
        id: "Valecek",
        class: "unselected",
      },
      {
        id: "Karabacek",
        class: "unselected",
      },
      {
        id: "Klizka",
        class: "unselected",
      },
      {
        id: "Ohanka",
        class: "unselected",
      },
    ],
  };

  onMouseClickedHandler = (id) => {
    const animParts = this.state.parts;

    //  console.log('toto je moje id:' + id)

    const PartIndex = this.state.parts.findIndex((p) => {
      return p.id === id;
    });

    // udelam si kopii vybrane casti tela
    const part = {
      ...this.state.parts[PartIndex],
    };
    // predelam barvu
    part.class = "selected";

    //    console.log('nova barva je : ' + part.class)
    // kopie state
    const parts = [...this.state.parts];

    //   console.log('soucasne cast : ' + parts)

    // vsechny kopie vyresetuji barvu
    parts.map((p) => (p.class = "unselected"));
    // pridam nove upravenou cast tela
    parts[PartIndex] = part;

    //    console.log(parts)
    // set state...
    this.setState({ parts: parts });

    //  const animPartnew = this.updateObject(animParts, {:'ZSelected'});

    this.props.onFindTextKompl(id);
  };

  render() {
    //   SVG Byk
    const cast = this.state.parts;
    return (
      <div className="KurzAnimalContainer">
        <svg
          id="bykKomplet"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 706.18 433.2"
        >
          <defs />

          <g id="Vrstva_2" data-name="Vrstva 2">
            <g id="Vrstva_1-2" data-name="Vrstva 1">
              <g id="byt_pokrocile">
                <path
                  id="byk"
                  class="bykKompletni-1"
                  d="M24.23,18.43c-3.3,6.61-7.44,13.92-3.18,21.23a25.14,25.14,0,0,0,7,7.45,39.28,39.28,0,0,0,10,5.11c3.72,1.33,7.52,1.8,11.11,3.57a20.79,20.79,0,0,1,8.41,6.9,10.28,10.28,0,0,1,1.06,9.76h0a17.79,17.79,0,0,1-4.64,6h0L19.24,99.92a65.86,65.86,0,0,1-11.37,5.34A8.06,8.06,0,0,0,6,106.34a14.82,14.82,0,0,0-5.56,9.19h0A27.77,27.77,0,0,0,.55,126h0c1.62,9.08,3.81,19.6,9.52,27.1a24.34,24.34,0,0,0,5.35,5.18h0c6.91,4.89,14.93,4,22.92,3.77a69.54,69.54,0,0,1,23.6,3.11c5.22,1.73,9.9,4.73,14.62,7.48l11.2,6.51,2.73,1.59h0s17,13.46,35.79,7.47c0,0,13.46-6.39,28.7,17,2,3.07,3.48,6.54,5.48,9.65a94.1,94.1,0,0,0,8.59,11.39c3.3,3.72,7,7,10.36,10.7,4.36,4.72,8.78,9.6,12.19,15.08,1.83,2.95,3.3,6.1,5.25,9a61.64,61.64,0,0,0,14.87,15.81c3.72,2.68,7.69,4.87,11,8.07a37.78,37.78,0,0,1,7.72,10.66c2.19,4.57,3,9.65,3.88,14.62a226.81,226.81,0,0,1,3.12,25.72,150,150,0,0,1,.1,17.74h0c-.06,5.05-.23,10.09-.45,15.13-.42,9.48-1,19-2.32,28.39-.32,2.3-.69,4.6-1.18,6.87a10.11,10.11,0,0,1-.9,3c-.8,1.36-2.28,2.2-3.22,3.44a18.09,18.09,0,0,0-3.89,9.87c-.12,2.76.73,7.51,3,9.45,1.2,1,4,1.22,5.54,1.57,2,.45,4,.85,6,1.14,6.31.89,13.64,1.37,19.53-1.52a9.82,9.82,0,0,0,5-7.36c.4-2.3-.68-7.14,2.63-7.73,1-.19,1.93.47,2.9.36h0c3.06-.35,4.59-4.14,4.92-6.76h0c.65-5-1.54-9.52-2.11-14.4h0a224.84,224.84,0,0,1-1.56-27.82,132.67,132.67,0,0,1,2.52-26.9,58.92,58.92,0,0,1,4.35-13.33s6.32-10.75,6.32-19.14c0,0,5-4.6,9.27,18.78l4.25,23.39s3.54,21.61-4.25,41.1c0,0-8.08,14.17-4,22.68,0,0,3.11,12.4,24.59,6.38l12-3.19s8.44-1.07,5.46-12.05h0a26.62,26.62,0,0,1,.37-5.42,13.69,13.69,0,0,1,1.12-3.86c.71-1.36,2-2.17,2.91-3.33h0c4.58-5.62,3.52-14.52.57-20.63-1.1-2.28-2.55-4.42-3.09-6.94a73.18,73.18,0,0,1-1.11-8.61c-.54-5.94-.7-11.91-.75-17.88h0c0-2.92-.4-5.55.31-8.43a28.5,28.5,0,0,0,.55-2.9,64.23,64.23,0,0,0,.3-12.4c-.21-3.86-.92-7.68-1.18-11.52,0,0-1.67-25.29,7.07-28.12,0,0,15-11,50.9,0h0c5.27,1.47,10.65,2.61,16,3.66a205.88,205.88,0,0,0,34.63,4.09c3.45.08,6.92.06,10.37-.2,3.84-.28,7.52-1.57,11.36-1.84a23.13,23.13,0,0,1,17.24,5.5,42.21,42.21,0,0,0,3.17,3.11h0a19.67,19.67,0,0,0,13.79,3.39h0c5.82-.69,9.08-4.6,13.82-7.4,4.56-2.69,10.19-1.67,14.78.4h0a31.53,31.53,0,0,1,8.91,5.91c2.61,2.52,4.2,5.75,5.83,8.94a125.16,125.16,0,0,1,6.76,16,96.74,96.74,0,0,1,5.63,29.23,69.43,69.43,0,0,1-.37,8.89h0a65.47,65.47,0,0,0-.24,13.35,24.7,24.7,0,0,0,1.46,6.29c.73,1.86,2.37,3.47,2.68,5.46a19.09,19.09,0,0,1-.1,4.95c-.49,4.3-1.46,8.65-4.16,12.14h0s-9.84,17.85-2.83,21.68c0,0,15.15,8,34.37,1,5.47-2,4.43-11,4.55-15.35.06-2.35.56-5.7,3.2-6.46,1.89-.54,3.77,1,5.23-.89a5.7,5.7,0,0,0,.89-2c1.38-5.06,0-11-1.12-16h0c-4.42-12.69-4.76-27.91-.14-40.6a49.72,49.72,0,0,1,2.4-5.5c.48-.92,1-1.82,1.52-2.71.22-.37,1.73-2.19,1.66-2.56h0q.57,3.14,1.13,6.27c.28,1.51.6,3,.82,4.54.19,1.34.06,3.05.83,4.23a9.18,9.18,0,0,0,1.37,1.08,27.2,27.2,0,0,1,5.76,7.73h0c4.11,7.86,5.86,17.51,7.2,26.22a63.62,63.62,0,0,1,.77,8A59.31,59.31,0,0,1,616,406.77h0s-11.29,17.4,3.15,20.33c0,0,25.55,9.44,28-4.74,0,0-2.83-24.09,7.8-22.32.48.08.72-3,.73-3.2.47-6.25-.43-12.7-1.2-18.89-.41-3.32-.88-6.63-1.38-9.94-.47-3.1-2.14-6.46-1.81-9.59.28-2.6,2.64-4.18,3.62-6.59h0a17.44,17.44,0,0,0,0-12.62c-.41-1.12-1.28-2.3-1.57-3.37a13.33,13.33,0,0,1-.14-3.34h0c0-2.91,0-6.74,2.57-8.69,1.76-1.33,2.82-1.7,3.81-3.85h0c3.45-7.54,2.75-17.16,1.2-25.08-.7-3.56-1.39-8-3.1-11.2,0,0-6.34-12.06,6.8-44.15,0,0,11.34-20.2,6.55-124.73,0,0,9-11,13.64,15.07l2.84,65.72,2.12,32.6s2.1,27.3-5,39.13c0,0-12.53,25.6,5.25,35.76v-7.17l3.61,4.92L695,294.1l2.12,1.81h0c3.18-7.9,7.31-16,8.64-24.42a28.27,28.27,0,0,0-.28-11.37h0c-1.28-5-4-9.33-5.17-14.41h0a90.11,90.11,0,0,1-1.78-22.47,44.57,44.57,0,0,1,.87-7.81,175.92,175.92,0,0,0-1.57-48.73s-5.23-21.87,1.57-41.89c0,0,13.67-64.49-23.89-74.63,0,0-25.81-6.57-65.2-.56,0,0-46.77,3.13-85.74,0,0,0-38.91.56-54,.56,0,0-30,1.58-50.18-.56,0,0-31.1-4.53-47.48.56,0,0-11.34,3.83-53.86-3.86-3-.55-6-1.43-9.12-1.89a95.92,95.92,0,0,0-22.27-.62,90.59,90.59,0,0,0-14.17,2.4c-7.71,2-14.41,5.48-21.64,8.61-14.78,6.39-32,7.18-47.83,5.74A156.7,156.7,0,0,1,187.88,58c-5.13-1-10.37-1.7-15.46-2.89a25.89,25.89,0,0,1-7.79-3h0c-2.21-1.37-2.9-3.23-.77-5.1,1.92-1.68,4.06-3.08,5.93-4.85,6.39-6,12.17-14.49,10.7-23.73h0c.13.82-13.23,2.56-14.32,2.62-4.06.22-7.71-.41-11.72.64h0c-8.41,2.21-16.66,5.44-22.76,11.89-1.1,1.17-2.79,4.42-4.2,4.57s-3.31-.95-4.82-1.11c-1.76-.19-4-.23-4.93,1.55h0c-3.61-2.15-7.36-4.25-10.78-6.69-2.4-1.7-4.36-3.63-7.14-4.89h0c-4.75-2.13-9.52-2.72-14.65-3a47.36,47.36,0,0,1-6.92-.83c-6.58-1.27-13.57-4-17.5-9.74a17.15,17.15,0,0,1-2.54-5.87C58,6.82,57,.22,57.89,0c0,0-13.82,3.54-10.63,17.36,0,0-3.19,13.82,26.22,22,4.13,1.15,9.43,3.51,11.6,7.39.57,1,1.62,4-.42,4.15h0c-1.67.09-2.72-2-3.53-3.14h0c-4.64-6.54-12.78-7.39-20.13-8-2.14-.17-4.28-.34-6.4-.67a80.68,80.68,0,0,1-11.81-3.16h0c-2.68-.85-5.45-1.74-7.64-3.57s-3.64-4.21-5.26-6.44c-.69-.94-6.15-6.5-5.66-7.48Z"
                />
                <g id="pravapredni">
                  <path
                    class="unused"
                    d="M289.84,306.28c1.62,1.93,3.23,4.41,4.15,10.87q.78,5.37,1.54,10.72-.7-5-1.43-10.05c3.44,22.21,12.25,47.71,3,69.07,0,0-7.82,18-4.28,27,0,0,1.4,10.4,34.53.16,0,0,3.19,1.41,2.66-12.1-.33-8.41,3.75-9.43,5.58-16.63,1.18-4.67-.93-8.34-2-12.69a186.62,186.62,0,0,1-3.71-23.49c-.87-8.32-.08-15.45.72-23.56,1.55-15.7-3.32-33.24,1.48-48.6-11.43,5.18-32.12,16-42.25,29.33Z"
                  />
                </g>
                <g id="pravazadni">
                  <path
                    class="unused"
                    d="M516.4,281.23c3.37.13,2.76,0,4.15.23,26.37,4.88,35.24,45.87,34.31,66.66,0,0-.82,18.61,3.07,26.15,0,0,3.28,14.64-3.81,23,0,0-7,14.55-2.53,19.65,0,0,10.2,6.19,30.84-.74,0,0,2.41.47,2.73-11.14,0,0-.79-10.39,6.89-10.06,0,0,6,.4,0-17.16-5.84-17.06-.17-40.64,6.56-57.14h0c.12-.29-1.08-1.91-1.26-2.22L596,316.28c-.85-1.42-1.69-2.84-2.46-4.3a25.47,25.47,0,0,1-3-9.15,18.19,18.19,0,0,1-.09-2.95h0a33.92,33.92,0,0,0-1.21-11.52c-.32-1.07-.7-2.14-1.12-3.18h0a36,36,0,0,0-5-8.22,23.68,23.68,0,0,0-7.64-5.94,11.62,11.62,0,0,0-2.57-.87h0c-2.11-.43-4.24,0-6.37-.22-2.93-.27-5.75-1.21-8.69-1.51h0a24.89,24.89,0,0,0-11.3,1.1c-9,3.38-17.93,6.9-26.87,10.4h0l-3.32,1.31Z"
                  />
                </g>
                <g id="levazadni">
                  <path
                    class="unused"
                    d="M617.51,364.28s8.27,27.17-.5,43c0,0-6.39,15.89,2,17.42,0,0,14.92,4.53,21.92,1.2,0,0,5.35,2,3.66-13.64,0,0,0-15.36,8.4-16.17,1.84-.18-4.48-33.76-3.81-37,0,0-35.73-12.75-31.72,5.23Z"
                  />
                </g>
                <g id="levapredni">
                  <path
                    class="unused"
                    d="M239.88,345.22c.19,6.46.25,12.92.13,19.39-.12,6.24-.4,12.49-1.07,18.71h0s-.85,23.24-5.1,26.64c0,0-7.37,7.37-4.26,16.73,0,0,17,5.95,26.93,2,0,0,5.1-1.7,5.1-10.77,0,0,2.27-8.51,6.81-6.24,0,0,6.23-1.13,1.7-14.17h0c-.55-5.78-.86-11.6-1.07-17.4-.38-10.44-.57-21,.63-31.4-17.83-11.08-29.82-4.35-29.8-3.47Z"
                  />
                </g>
                <g id="_19b_nad" data-name="19b_nad">
                  <path
                    class="unused"
                    d="M526.42,190a195.94,195.94,0,0,1-11.52-53.15c-8.8-.25-17.28-1.16-25.29-.52-1.83,23-4.38,39.88-8.05,55.16C497.07,193.25,511,193.24,526.42,190Z"
                  />
                </g>
                <g id="hlava">
                  <path
                    class="unused"
                    d="M180.36,59.89c-10.15-3.14-30.52-5.35-17.16-15.21,0,0,12.46-9.18,14.31-24.22,0,0-4.31,2-12.75,1.83,0,0-24.61.61-36.09,20.56,0,0-6.92-3.49-10.22-1.3C114.77,44,101.16,30.39,96,29,79.58,24.51,55.67,28,55.36,4.61a43.83,43.83,0,0,0-4.9,5.06c-1.85,3.82-1.06,8.46.48,12.28,6.16,15.29,39,12.67,37.3,29.56,0,0-.53,5.3-9.27-2.38C63.8,35.8,32.3,45.12,24.7,22.64c.75,2.22-2.64,8-1.64,11.61C26.82,48,42.56,48.74,52.94,54.43c10.61,5.83,13.93,18.36,1.66,26L16.33,104.08c-4.41,2.73-9.1,3.12-11.71,8.56-4.64,9.65,1.44,28,6.72,36.56,8.66,14.13,33.79,6.55,47.41,11.46,16.34,5.88,30.29,17.8,46.85,23.75,10,3.59,13.93,1.11,23.3.58a18.25,18.25,0,0,1,8.52,1.66C162.07,154.9,189.7,93.24,180.36,59.89ZM73.71,145.75c-2,4.41-7.08,5.93-12,7.41l-2.24.68c-4.3,1.36-14,2.8-23.51,2.8h0c-12.72,0-20.29-2.49-22.51-7.41a6.69,6.69,0,0,1,0-6c3-5.79,14.84-8.17,27.41-10.68,2.44-.49,5-1,7.29-1.5a61.4,61.4,0,0,1,12.74-1.62c8.1,0,10.6,2.74,11.37,4.37C74.61,138.74,75.09,142.66,73.71,145.75Zm65.47-28.59c-.45,5.17.36,10.63-3.58,14.84-2.8,3-6.77,3.39-10.65,3.22-3.52-.16-7.11-.83-10.62-.2s-6.49,2.4-9.34,4.21c-5.9,3.74-11.55,8.59-18.84,9.05-7.1.44-11.91-4.72-12.31-11.57-5.62-13.85,10.73-23.63,20.41-29.57,1.67-1,3.41-2.22,5.21-3.46,8.69-6,18.79-13.22,29.08-9.39h0C138.32,97.94,140,108.06,139.18,117.16Z"
                  />
                </g>
                <g id="_12a13_new" data-name="12a13_new">
                  <path
                    class={findClass(cast, "ZHole")}
                    onClick={() => this.onMouseClickedHandler("ZHole")}
                    d="M195.29,191.23c-3.3,2.22-8.45,6.89-13.4,11.74C191.33,209.83,215,223.2,215,223.2c-10.74-24.46-3.84-44.09.86-53.4-2.53-.88-4.21-2-6.74-2.87C204.45,178,200.1,188,195.29,191.23Z"
                  />
                  <path
                    class={findClass(cast, "VZebro")}
                    onClick={() => this.onMouseClickedHandler("VZebro")}
                    d="M226.49,141.14c-3.26,1.88-6.07,3.5-7.81,5.54-2.17,2.54-5.34,10.11-8.4,17.43l-.5,1.18c2.53.88,4.59,1.52,7.12,2.4a24,24,0,0,1,2.57-4.34c3-3.68,5.27-8.41,7.41-12.63a130.32,130.32,0,0,0,5.84-13.39C230.49,138.82,228.39,140,226.49,141.14Z"
                  />
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Jazyk")}
                  id="_2"
                  data-name="2"
                >
                  <path
                    class={findClass(cast, "Jazyk")}
                    d="M70.2,134.74c-.87-1.85-5.72-5-21.57-1.5s-37.22,6-33.14,15.06,34.9,6,43.26,3.38S76.37,147.75,70.2,134.74Z"
                  />
                  <g id="_1" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M45.58,152.56a8.5,8.5,0,1,0-8.51-8.5,8.5,8.5,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(42.96 147.53)"
                  >
                    2
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Licka")}
                  id="_1-2"
                  data-name="1"
                >
                  <path
                    class={findClass(cast, "Licka")}
                    d="M99.78,106.11c-1.66,1.12-3.27,2.2-4.82,3.13-9,5.4-24.09,14.3-18.5,26.18h0c.54,6,5.17,10.31,11.83,9.75,6.84-.57,12-4.92,17.49-8.32a26.45,26.45,0,0,1,8.68-3.88c3.28-.64,6.67-.15,10-.1,3.65.06,7.37-.38,9.93-3.05,3.61-3.76,2.73-8.48,3-13,.54-7.92-1.25-16.67-10.52-19.6h0c-9.75-3.08-19.08,3.46-27.1,8.87Z"
                  />
                  <g id="_1-3" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M106,129.26a8.5,8.5,0,1,0-8.5-8.5,8.5,8.5,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(104.01 124.23)"
                  >
                    1
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Krk")}
                  id="_3"
                  data-name="3"
                >
                  <path
                    class={findClass(cast, "Krk")}
                    d="M139.89,187.26s55.59-68.67,42.92-127c0,0,38.33,9.33,60.57,1,0,0,16,38.62,4.4,57.25s-25.1,20-30.82,26.76S201.8,184.08,194,189.35s-25.61,23.7-27.74,27.25C166.28,216.6,150.35,188.92,139.89,187.26Z"
                  />
                  <g id="_1-4" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M211.32,108.25a8.51,8.51,0,1,0-8.51-8.51,8.51,8.51,0,0,0,8.51,8.51Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(208.7 103.21)"
                  >
                    3
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Hrudi")}
                  id="_4"
                  data-name="4"
                >
                  <path
                    class={findClass(cast, "Hrudi")}
                    d="M228.61,285.59c.29-11.49,0-23.09-2.51-34.36a80.92,80.92,0,0,0-2.73-9.53,114.71,114.71,0,0,0-5.77-13c-3.09-5.49-9.13-5.41-17.14-11.11-8.66-4.64-14.8-9.11-21.61-11.62-5.22,5.28-9.68,10.2-10.63,11.78l-.34.57c9.3,10.07,19.42,19.49,26.42,31.36a114.5,114.5,0,0,0,11.08,16.11c7.53,8.85,14.44,9.86,23.34,23C228.23,288.1,228.59,286.39,228.61,285.59Z"
                  />
                  <g id="_1-5" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M204.45,244.5A8.5,8.5,0,1,0,196,236a8.49,8.49,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(201.39 239.47)"
                  >
                    4
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("KPlec")}
                  id="_7"
                  data-name="7"
                >
                  <path
                    class={findClass(cast, "KPlec")}
                    d="M259.68,105a18.82,18.82,0,0,0-6,3.18,30.43,30.43,0,0,1-4,11.49,57.18,57.18,0,0,1-12.38,14.27q-1.59,4.53-3.49,8.94c-1,2.35-2.1,4.67-3.26,6.95a86.91,86.91,0,0,1-5.25,9s-26.08,31.18-7.09,64.06a49.61,49.61,0,0,1,3.6,9.12,15.65,15.65,0,0,1,7.41-1.68,23.27,23.27,0,0,1,8.59,1.76,68.08,68.08,0,0,1,7.47,3.44C242.64,191.46,245,147.25,259.68,105Z"
                  />
                  <g id="_1-6" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M228.62,201.66a8.51,8.51,0,1,0-8.5-8.51,8.5,8.5,0,0,0,8.5,8.51Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(225.88 196.63)"
                  >
                    7
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("LPlec")}
                  id="_8"
                  data-name="8"
                >
                  <path
                    class={findClass(cast, "LPlec")}
                    d="M308.7,117.57c-4-4.24-8.42-7.46-16.75-10.92A53.28,53.28,0,0,0,278,102.72c-5.55-.68-9.78-.61-15,1.09-14.64,42.27-18.9,88.45-16.24,132.5,7.4,3.89,15.83,9.3,18,13.93q4,8.26,8.63,12.62C272.57,232.61,284.48,147.82,308.7,117.57Z"
                  />
                  <g id="_1-7" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M268.18,171.38a8.5,8.5,0,1,0-8.5-8.5,8.5,8.5,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(265.25 166.35)"
                  >
                    8
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("VPlec")}
                  id="_9"
                  data-name="9"
                >
                  <path
                    class={findClass(cast, "VPlec")}
                    d="M317.46,129.9A37.33,37.33,0,0,0,310.07,119c-20.84,26.23-36,114.93-35,145.17,2.41,2.25,3.42,2.4,6.07,3l1.48.11a60.77,60.77,0,0,1,6.17-14.18A81.28,81.28,0,0,1,297.61,241s34.59-23.81,34.3-56.13C331.91,184.89,333.05,161.93,317.46,129.9Z"
                  />
                  <g id="_1-8" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M308.71,197.27a8.51,8.51,0,1,0-8.51-8.5,8.5,8.5,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(305.88 192.24)"
                  >
                    9
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("VZebro")}
                  id="_12"
                  data-name="12"
                >
                  <path
                    class={findClass(cast, "VZebro")}
                    d="M369.76,150.1l-4.12.86.75-4.13a41.08,41.08,0,0,0,.28-9.34,368.62,368.62,0,0,0-43.38-.72c.32,0,1.55,2.95,1.67,3.22a90.16,90.16,0,0,1,3.8,9.08,97.29,97.29,0,0,1,5.78,31,78,78,0,0,1-2,20.09c13.5,3.78,27.83,6.47,41.29,9.35a599.08,599.08,0,0,0,6.65-60.63C375.49,149.41,370.71,149.9,369.76,150.1Z"
                  />
                  <g id="_1-9" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M355.76,184.65a8.51,8.51,0,1,0-8.5-8.5,8.51,8.51,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(350.80 179.62)"
                  >
                    12
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("ZHole")}
                  id="_13"
                  data-name="13"
                >
                  <path
                    class={findClass(cast, "ZHole")}
                    d="M332,202.35c-1.24,4.9-4.21,9.13-6.83,13.37a131.35,131.35,0,0,1-8.81,13.09c-2.39,3-9.79,11.4-14.85,13.82,5.62,1.3,41.06,1.21,62.71,6.75,1.71-4.54,5.43-15.35,9.2-37.68-13.46-2.88-27.93-5.57-41.42-9.35C331.89,202.78,332.1,201.92,332,202.35Z"
                  />
                  <g id="_1-10" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M343.36,231.7a8.51,8.51,0,1,0-8.5-8.5,8.5,8.5,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(338.03 226.67)"
                  >
                    13
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Hrudi")}
                  id="_4_2"
                  data-name="4_2"
                >
                  <path
                    class={findClass(cast, "Hrudi")}
                    d="M360.49,267.52S364.76,253.64,363,253c-18.5-6.7-30.6-2.51-63.34-8.49-4.1.82-18.51,23.37-16,41.09,0,0,3.9,11,1.42,17.72l3.19,1.42s20.19-33,72.28-37.21Z"
                  />
                  <g id="_1-11" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M310,271.36a8.51,8.51,0,1,0-8.5-8.5,8.5,8.5,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(306.95 266.33)"
                  >
                    4
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Husicka")}
                  id="_10"
                  data-name="10"
                >
                  <path
                    class={findClass(cast, "Husicka")}
                    d="M261.32,250.94c-2.54-5.28-15.3-13.15-24.33-16.76s-14.4,1.33-14.4,1.33l6.85,21.87c13.84,6.52,29.1,8.05,44.53,9C267.66,262,263.16,254.76,261.32,250.94Z"
                  />
                  <g id="_1-12" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M241.22,255.91a8.51,8.51,0,1,0-8.5-8.51,8.5,8.5,0,0,0,8.5,8.51Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(236.28 250.88)"
                  >
                    10
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("KPredni")}
                  id="_11"
                  data-name="11"
                >
                  <path
                    class={findClass(cast, "KPredni")}
                    d="M282.56,292.89c-1.17-7.26-2.38-14-1-21.32.12-.63,1-1.83.4-1.88-1.61-.25-18.08-1.59-31.79-4.16a129.86,129.86,0,0,1-19.92-5.47c.86,6.45.24,12.72.63,19.35A125.21,125.21,0,0,0,235,303.62c1.52,5.88,3.23,11.6,3.67,17.69.26,3.64.47,7.28.66,10.92q.25,5.17.44,10.35c7.8-5.26,23.67.13,30.17,3.52,1.74-14.52,10.6-26.49,12.62-40.88A41.43,41.43,0,0,0,282.56,292.89Z"
                  />
                  <g id="_1-13" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M256.66,297.45a8.5,8.5,0,1,0-8.51-8.5,8.5,8.5,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(252.23 292.42)"
                  >
                    11
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Podpleci")}
                  id="_5"
                  data-name="5"
                >
                  <path
                    class={findClass(cast, "Podpleci")}
                    d="M306.32,46.66c-34.31-2.44-48.23,7.55-48.23,7.55l-12.76,5.32c1.44,1.43,2.33,4.4,2.85,8.22,2.92,8.82,7,24,5.91,37.17,14.5-8.62,31.64-3.58,31.64-3.58a43.19,43.19,0,0,1,11.62,4C303.29,86.11,307.1,66.66,306.32,46.66Z"
                  />
                  <g id="_1-14" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M277.41,88.23a8.51,8.51,0,1,0-8.51-8.5,8.51,8.51,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(274.78 83.2)"
                  >
                    5
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("VRostenec")}
                  id="_6"
                  data-name="6"
                >
                  <path
                    class={findClass(cast, "VRostenec")}
                    d="M381,51C361.2,56.69,318,47.84,318,47.84c-3.85-.52-6.55-.82-10-1.06a180.26,180.26,0,0,1-8.09,59.67c18.42,9.52,22,26.42,22,26.42l44.35,1.32a22.7,22.7,0,0,0-2.65-7.32l-1.81-3L373.34,120l9.05-2.5C382.42,92.7,381,51,381,51Z"
                  />
                  <g id="_1-15" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M341.14,95.63a8.51,8.51,0,1,0-8.51-8.5,8.51,8.51,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(338.31 90.6)"
                  >
                    6
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Veverka")}
                  id="_15"
                  data-name="15"
                >
                  <path
                    class={findClass(cast, "Veverka")}
                    d="M374.17,122.69h0l7.66-2.12,11.63-3.22a28.46,28.46,0,0,1,6.92-1.09c2.77-.08,5.9.14,8.26,1.74h0c2.39,1.61,8.27,11.23,8.32,13.8h0c.05,2.58-1.57,4.75-2.82,6.87h0a9.24,9.24,0,0,1-6.28,4.13h0c-6.85,1.54-35.65,3.89-38.7,4.53h0s2.29-12.75-3.18-21.92l8.17-2.72Z"
                  />
                  <g id="_1-16" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M392.52,140.29a8.51,8.51,0,1,0-8.5-8.51,8.5,8.5,0,0,0,8.5,8.51Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(387.28 135.26)"
                  >
                    15
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Oponka")}
                  id="_14"
                  data-name="14"
                >
                  <path
                    class={findClass(cast, "Oponka")}
                    d="M394,154.55c-.38-2.92-.06-2.93-.77-7.65,6.06-1.06,8.59-1.4,15-2.36,1.59,7.42,2,17.67,2,22.79h0a372.86,372.86,0,0,1-1.76,40.8q-.66,6.17-1.36,12.32c-.41,3.54-1,7.39-3.31,10.25h0a12.69,12.69,0,0,1-9.31,4.44h0c-2.19.12-4.74.8-6.85-.06s-3-3-3.31-5h0c-.78-4.43.33-8.42,1.48-12.62q1.56-5.7,2.89-11.46a224.1,224.1,0,0,0,5.43-33c.12-1.44.25-1.34-.09-18.45Z"
                  />
                  <g id="_1-17" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M395.82,228.47a8.51,8.51,0,1,0-8.51-8.5,8.51,8.51,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(390.55 223.44)"
                  >
                    14
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("ZNizke")}
                  id="_18"
                  data-name="18"
                >
                  <path
                    class={findClass(cast, "ZNizke")}
                    d="M487.23,136.32c-25.19-.29-47.29,0-68.67.37-.44.89-.94,1.72-1.4,2.47l-.58,1a11,11,0,0,1-5.44,4.61c1.73,8.75,1.87,20.32,1.88,22.6a370,370,0,0,1-1.79,41.12q-.64,6.17-1.36,12.33c-.47,4.07-1.16,8.32-3.92,11.72A15.42,15.42,0,0,1,394.59,238c-.51,0-1,.09-1.58.16a26,26,0,0,1-2.91.21,9.3,9.3,0,0,1-3.58-.63c-2.62-1.07-4.41-3.62-5-7.18-.87-5,.34-9.45,1.51-13.74l0-.11c1-3.68,2-7.5,2.87-11.36a220.53,220.53,0,0,0,5.37-32.54l0-.32c.1-1.06.19-2.16-.12-17.7a27.08,27.08,0,0,1-.23-2.7,40.55,40.55,0,0,0-.43-4.16l-6.72.68c-1,21.2-4.12,69.08-19.51,119,14.29,1,30.8,6.72,38.39,7.86,12.3,1.83,24.8,4.43,37.22,3.55C484.51,213,488,136.33,487.23,136.32Z"
                  />
                  <g id="_1-18" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M440.22,201.66a8.51,8.51,0,1,0-8.5-8.51,8.51,8.51,0,0,0,8.5,8.51Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(435.07 196.63)"
                  >
                    18
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Svickova")}
                  id="_17"
                  data-name="17"
                >
                  <path
                    class={findClass(cast, "Svickova")}
                    d="M532.8,119.57c-5.9.48-7.2.55-13.12.71a97.62,97.62,0,0,0-10.44-.41c-7.13.1-14.27,0-21.39-.27q-8.25-.28-16.48-.83c-2.5-.17-5.14-.21-7.61-.58-3-.43-5.95-.73-8.95-.94q-3.24-.21-6.49-.3c-6.76-.19-13.67.33-20.39-.3-3.12-.29-7.37-.78-9.39-2.83-1.26-1.27-1-2.86-.15-4.23a14.94,14.94,0,0,1,3.55-3.7,15.84,15.84,0,0,1,5.4-2.7,36.06,36.06,0,0,1,5.91-1.11,96.62,96.62,0,0,1,22,.33l1.43.19c6.2.91,12.56,0,18.72-.65,3.43-.35,6.89-.19,10.32-.5a195.77,195.77,0,0,0,20.75-3.32,16.93,16.93,0,0,0,3.52-1,26.06,26.06,0,0,1,3-1,50.54,50.54,0,0,1,6-1.34c1.51-.26,12.4-4.33,14.17-3.29C536,91.24,538.86,119.07,532.8,119.57Z"
                  />
                  <g id="_1-19" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M509,116.75a8.51,8.51,0,1,0-8.5-8.5,8.51,8.51,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(504.08 111.72)"
                  >
                    17{" "}
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("NRostenec")}
                  id="_16"
                  data-name="16"
                >
                  <path
                    class={findClass(cast, "NRostenec")}
                    d="M495.29,51.64c-27.2.1-54.19,2.35-81.34-.72-10.39-1.17-20.76-.73-31.14-.19,2.08,21.63,2.31,48.58,2.19,66l7.71-2.14a31.53,31.53,0,0,1,7.59-1.2h1c3.78,0,6.7.73,8.93,2.24,3,2,9.5,12.46,9.57,16.09a9.58,9.58,0,0,1-.2,2c3.9,0,7.79-.05,11.69-.06q12,0,24,0,13.61,0,27.21.1,14.28.1,28.57.3l3.65.06c.15-3.46.41-6.92.82-10.4l-4.42.12c-7.57.12-15.14,0-22.69-.37q-8.75-.39-17.48-1.13a80.7,80.7,0,0,1-8.07-.77,94,94,0,0,0-9.49-1.27c-2.28-.2-4.58-.33-6.88-.41-7.17-.26-14.5.44-21.63-.41-3.3-.39-7.81-1-9.95-3.82-1.34-1.72-1-3.87-.16-5.71a18.82,18.82,0,0,1,3.76-5,15.74,15.74,0,0,1,5.73-3.65,32,32,0,0,1,6.27-1.51,81.29,81.29,0,0,1,23.36.45l1.52.26c6.57,1.23,13.32,0,19.85-.88,3.64-.46,7.31-.25,10.95-.67a166.28,166.28,0,0,0,22-4.5,14.42,14.42,0,0,0,3.73-1.4,25.47,25.47,0,0,1,3.15-1.42,45.66,45.66,0,0,1,6.32-1.81c1.11-.24,2.2-.43,3.29-.59a117.06,117.06,0,0,1,25.79-36.64C540,52.14,510.78,51.58,495.29,51.64Z"
                  />
                  <g id="_1-20" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M453.87,88.23a8.51,8.51,0,1,0-8.5-8.5,8.51,8.51,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(448.84 83.2)"
                  >
                    16
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Holubicka")}
                  id="_20"
                  data-name="20"
                >
                  <path
                    class={findClass(cast, "Holubicka")}
                    d="M532.23,122.17c-5,.43-8.13.62-13.1.84-2.08,19.09.44,42.21,11.5,69.94,7.4-18.77,10.1-36.72,16.13-56.83C544.43,132.23,536.56,127.18,532.23,122.17Z"
                  />
                  <g id="_1-21" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M532,151.15a8.51,8.51,0,1,0-8.5-8.5,8.51,8.51,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(526.62 146.12)"
                  >
                    <tspan class="bykKompletni-4">2</tspan>
                    <tspan x="5.21" y="0">
                      1
                    </tspan>
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("PupekFlap")}
                  id="_19_b"
                  data-name="19_b"
                >
                  <path
                    class={findClass(cast, "PupekFlap")}
                    d="M527.41,192.76C512,196,496.47,195.75,481,194a203.55,203.55,0,0,1-10.71,32.71c26.74,9.41,57,17.5,74.8,41.18,1.7-.54,1.69-.55,3.37-1.16a35.42,35.42,0,0,1,4-1.28c3.71-.88,7.65.18,11.33.77,1.12.18,2.24.34,3.37.44s2.5.13,3.75.19C571.55,266.9,544.28,239.15,527.41,192.76Z"
                  />
                  <g id="_1-22" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M511.4,226.56a8.51,8.51,0,1,0-8.5-8.5,8.5,8.5,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(505.78 221.53)"
                  >
                    20
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("PupekFlank")}
                  id="_19_a"
                  data-name="19_a"
                >
                  <path
                    class={findClass(cast, "PupekFlank")}
                    d="M468.86,230.05c-8.31,19.87-17.1,32.73-25.73,48.93,9.46-.07,18.88-2.71,28.28-.66,6.78,1.48,9.94,6.06,15.49,8.71,6,2.88,9.65,3.52,18.41-2.28,1.29-.86,2.64-1.63,4-2.39q2.85-1.61,5.79-3c2.67-1.3,5.38-2.51,8.11-3.65,3.59-1.49,7.23-2.87,10.89-4.18,3.07-1.09,4.25-1.43,7.35-2.43C523.6,245.39,495.6,239.46,468.86,230.05Z"
                  />
                  <g id="_1-23" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M485.54,268.56a8.51,8.51,0,1,0-8.5-8.5,8.5,8.5,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(480.27 263.53)"
                  >
                    19
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Orech")}
                  id="_21"
                  data-name="21"
                >
                  <path
                    class={findClass(cast, "Orech")}
                    d="M580.36,124.92c-19.66,6.66-31.11,11.84-31.11,11.84s-9.89,40.67-17.3,59.44c7.57,19,17.32,36.52,33.91,59.37C595.19,216.29,614.35,165.06,580.36,124.92Z"
                  />
                  <g id="_1-24" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M559,197.27a8.51,8.51,0,1,0-8.5-8.5,8.49,8.49,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(553.24 192.24)"
                  >
                    22
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("VrchniSal")}
                  id="_25"
                  data-name="25"
                >
                  <path
                    class={findClass(cast, "VrchniSal")}
                    d="M664.4,104.74c-31.06,3.84-60.23,12.12-81.86,19.44,34,40.15,14.62,94.81-14.71,134.1,2.5,3.44,4,5.42,6.78,9.07a14.81,14.81,0,0,1,3.46,1.58,35.53,35.53,0,0,1,4,2.51,24.45,24.45,0,0,1,5.59,5.53,22.32,22.32,0,0,1,3.06,6.28c.73,2.32,6.09-5.46,18.56-5.46,0,0,13.89,3.69,21.26-6,0,0-.06-2.62,6-7.38C632.36,210.64,617,142.53,664.4,104.74Z"
                  />
                  <g id="_1-25" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M614.69,226.56a8.51,8.51,0,1,0-8.5-8.5,8.51,8.51,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(608.85 221.53)"
                  >
                    26
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Valecek")}
                  id="_26"
                  data-name="26"
                >
                  <path
                    class={findClass(cast, "Valecek")}
                    d="M666.78,110.24a33.06,33.06,0,0,0-.58-3.78c-.5.06-1.31.42-1.8.49-41.65,38.36-31.08,98.69-25.92,155.89a54.14,54.14,0,0,1,17.86-8.95c1.54-6.59,4.25-12.87,6.2-19C662.55,234.9,674.09,199.22,666.78,110.24Z"
                  />
                  <g id="_1-26" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M651.29,210a8.51,8.51,0,1,0-8.5-8.51,8.51,8.51,0,0,0,8.5,8.51Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(645.87 204.92)"
                  >
                    <tspan class="bykKompletni-4">2</tspan>
                    <tspan x="5.21" y="0">
                      7
                    </tspan>
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("KvetovaSpicka")}
                  id="_22"
                  data-name="22"
                >
                  <path
                    class={findClass(cast, "KvetovaSpicka")}
                    d="M581.48,52.69c-9.07.21-18.14.17-27.21,0-6,7-17.06,18.52-25.28,35.67a6.31,6.31,0,0,0,1.23,0c13.6-2.44,11.28,32.94,5.15,33.5h0c4.76,3.23,11.7,10.63,13.68,12.78,17.89-7.76,43.67-19.07,80.33-26.36-3-19.13-.89-40.85-11.93-57.71C604.74,51.42,594.08,52.4,581.48,52.69Z"
                  />
                  <g id="_1-27" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M578.33,99.74a8.51,8.51,0,1,0-8.5-8.5,8.51,8.51,0,0,0,8.5,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(572.71 94.71)"
                  >
                    23
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("TabulovaSpicka")}
                  id="_23"
                  data-name="23"
                >
                  <path
                    class={findClass(cast, "TabulovaSpicka")}
                    d="M648.89,49.7c-9.76-.27-18.8.17-28.61.78,11,16.86,9.08,38.26,12.05,57.39,10.24-2,20.83-4.31,33.55-5.51C662.32,77.07,651.68,49.78,648.89,49.7Z"
                  />
                  <g id="_1-28" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M642.79,84.48a8.5,8.5,0,1,0-8.51-8.5,8.5,8.5,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(637.15 79.45)"
                  >
                    24
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Ohanka")}
                  id="_29"
                  data-name="29"
                >
                  <path
                    class={findClass(cast, "Ohanka")}
                    d="M669.49,109.45c3.73-1.94,16.56-7.27,18,31.29L689,178.69s.8,29.63,1.84,41.27c0,0,2.36,34.75-2.67,43.5-5.81,10.11-8.78,26.72.21,35.92.43-2.77,1-5.55,1.5-8.31,1.3,2,2.56,2.83,3.25,5.39.08-2.56.48-5.14.65-7.69.61.73,1.35,1.36,2,2.09a89.78,89.78,0,0,1,5.74-16.37c4.44-7.85-5.37-32.26-5.08-43s2.42-21,1.92-31.73c-1.23-26.17-8.6-52.09-2.46-78.29,2.75-11.75,2.5-25,.14-36.75-4.33-21.48-13.81-32.94-36.16-34.7q-3.55-.27-7.14-.41c-.67,0,14.24,16.85,16.8,59.83Z"
                  />
                  <g id="_1-29" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M677.65,93a8.51,8.51,0,1,0-8.51-8.51A8.51,8.51,0,0,0,677.65,93Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(672.01 87.96)"
                  >
                    30
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Klizka")}
                  id="_28"
                  data-name="28"
                >
                  <path
                    class={findClass(cast, "Klizka")}
                    d="M657.6,309.58c-18.5-2.32-20.11-22.29-25.48-35.69a23.84,23.84,0,0,1-1.69,2.37,14,14,0,0,1-2.35,2.4c-3.46,2.72-8.24,3.76-12.56,3.72a11.78,11.78,0,0,1-3.69-.54c-1.13-.38-2.16-1-3.33-1.3-3-.69-6.2.54-9,1.54a59.88,59.88,0,0,0-6.81,2.88c-.12.06-1.33.58-1.3.74.26,1.56.62,3.11.82,4.69.33,2.7.52,5.4.73,8.11l.09,1.08c3.46,19.32,7.36,6.92,13.64,40.32,4.73,6.42,6.42,6.5,9.45,18.42.44,1.72-2.12-14.34,33.71-1.49-.11-6.47,2.88-6.71,2.54-11.35s-2.57-8.75-2.47-13.55c.14-6.51,4-9.26,6-14.51A22.2,22.2,0,0,0,657.6,309.58Z"
                  />
                  <g id="_1-30" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M620.28,320.08a8.5,8.5,0,1,0-8.51-8.5,8.5,8.5,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    id="28"
                    class="bykKompletni-3"
                    transform="translate(614.52 315.05)"
                  >
                    29
                  </text>
                </g>
                <g
                  onClick={() => this.onMouseClickedHandler("Karabacek")}
                  id="_27"
                  data-name="27"
                >
                  <path
                    class={findClass(cast, "Karabacek")}
                    d="M657.71,308c.5-10.49-4-20.46-4.64-30.93-.45-6.8.87-13.61,2.51-20.39a49.3,49.3,0,0,0-17.77,9.91,20.5,20.5,0,0,0-3.76,4.38c-.5.73-.19.27-.67,1C639.32,285,641.39,305.45,657.71,308Z"
                  />
                  <g id="_1-31" data-name="1">
                    <path
                      class="bykKompletni-1"
                      d="M644.17,281.56a8.5,8.5,0,1,0-8.51-8.5,8.5,8.5,0,0,0,8.51,8.5Z"
                    />
                  </g>
                  <text
                    class="bykKompletni-3"
                    transform="translate(638.53 276.53)"
                  >
                    <tspan class="bykKompletni-4">2</tspan>
                    <tspan x="5.21" y="0">
                      8
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
          </g>
        </svg>

        <svg
          id="sal"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 96.2 65.17"
        >
          <defs />

          <g
            onClick={() => this.onMouseClickedHandler("SpodniSal")}
            id="Vrstva_2"
            data-name="Vrstva 2"
          >
            <g id="Vrstva_1-2" data-name="Vrstva 1">
              <g id="_24" data-name="24">
                <path
                  class={findClass(cast, "SpodniSal")}
                  d="M1.3,22S61-3.42,94.44,1.81c0,0,9,51.31-37.9,61.22C14.29,71.83,1.3,22,1.3,22Z"
                />
                <path
                  class="sal-2"
                  d="M2.52,25.81C1.68,23.45,1.3,22,1.3,22s1.33-.56,3.7-1.51"
                />
                <path
                  class="sal-3"
                  d="M12.48,17.61c17-6.3,49.72-17.1,74-16.49"
                />
                <path
                  class="sal-2"
                  d="M90.47,1.34c1.36.11,2.68.27,4,.47,0,0,.26,1.47.46,4"
                />
                <path
                  class="sal-4"
                  d="M95.1,13.59c-.41,15.77-6,42.56-38.56,49.44-31.83,6.63-47-20-52.62-33.57"
                />
                <g id="_1" data-name="1">
                  <path
                    id="salCislo"
                    class="sal-5"
                    d="M48.22,41.4a8.51,8.51,0,1,0-8.51-8.51,8.51,8.51,0,0,0,8.51,8.51Z"
                  />
                </g>
                <text class="sal-6" transform="translate(43.21 36.36)">
                  <tspan class="sal-7">2</tspan>
                  <tspan x="5.1" y="0">
                    5
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </svg>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onFindTextKompl: (id) => dispatch(actions.findTextKompl(id)),
  };
};

export default connect(null, mapDispatchToProps)(BykKompletni);
